import { createFileRoute, Link, Outlet } from '@tanstack/react-router';
import { requireScope } from '~/auth/utils';
import { ScrollArea } from '~/primitives/scroll-area';
import { myActiveShiftsQuery } from '~/util/queries/staff/shifts';
import { CurrentShiftInfo } from './-CurrentShift';
import { Button } from '~/primitives/button';
import { LogOut } from 'lucide-react';
import { useApiMutation } from '~/util/hooks/useApiMutation';
import { claimSubmissionMutation } from '~/util/mutations/staff/submissions';
import { useList } from '~/util/hooks/useList';
import { ListTabSwitch } from '~/partials/TabSwitch';
import { submissionStatusQuery } from '~/util/queries/public/submissions';
import { SubmissionStatus } from './-SubmissionStatus';

export const Route = createFileRoute(
    '/_authenticated/staff/_submissionsLayout',
)({
    loaderDeps: ({ search: { list } }) => ({ list }),
    beforeLoad: async ({ context: { auth } }) => {
        requireScope(auth, 'submission_review');
    },
    loader: async ({ context: { queryClient }, deps: { list } }) => ({
        myShifts: await queryClient.fetchQuery(myActiveShiftsQuery()),
        submissionsEnabled: await queryClient.fetchQuery(
            submissionStatusQuery({ list }),
        ),
    }),
    component: Submissions,
});

function Submissions() {
    const list = useList();
    const navigate = Route.useNavigate();
    const claimSubmission = useApiMutation({
        ...claimSubmissionMutation(),
        onSuccess: ({ data }) => {
            navigate({
                to: '/staff/submissions/$submissionid',
                params: { submissionid: data.id },
                search: {
                    list,
                },
            });
        },
    });

    return (
        <main className="h-full flex justify-center">
            <div className="flex flex-col items-center gap-4 w-full h-full bg-background-dark rounded-2xl py-4">
                <ScrollArea className="w-full p-4 lg:h-[calc(100vh-150px)]">
                    <div className="flex flex-col xl:flex-row xl:justify-between items-center my-2 gap-2">
                        <div className="flex flex-col xl:flex-row items-center gap-2">
                            <div className="flex items-center gap-2">
                                <Link to="/staff/submissions">
                                    <h1 className="text-secondary-foreground hover:text-secondary-light transition-colors">
                                        Submissions Review
                                    </h1>
                                </Link>
                                <SubmissionStatus />
                            </div>
                            <ListTabSwitch from="/staff/submissions/" />
                        </div>
                        <Button onClick={() => claimSubmission.mutate(list)}>
                            <LogOut /> Claim a submission
                        </Button>
                    </div>
                    <CurrentShiftInfo />
                    <Outlet />
                </ScrollArea>
            </div>
        </main>
    );
}
